import React, { useLayoutEffect } from 'react'
import getRoutes from './routes'
import { createGlobalStyle } from 'styled-components'
import { initializeRemLayout, relativeLength } from './utils/layout'

const GlobalStyle = createGlobalStyle`
  body * {
    box-sizing: border-box;
  }
  #root {
    width: 100%;
    height: 100%;
    
    .am-navbar-light {
      border-bottom: ${relativeLength(1)} solid #ECECEC;
    }
  }
`

function App() {
  useLayoutEffect(() => {
    initializeRemLayout()
  }, [])

  return (
    <>
      <GlobalStyle />
      {getRoutes()}
    </>
  )
}

export default App
